import React, { memo } from 'react';

import { Box } from '@mui/material';
import StatusIconCDS from 'app/shared/componentsRestyled/coreDesignSystem/StatusIconCDS';
import PropTypes from 'prop-types';

import { StatusEnum } from 'constants/status';

const BooleanCellContent = ({ isChecked = false }) => {
  const status = isChecked ? StatusEnum.SUCCESS : StatusEnum.ERROR;
  const color = isChecked ? 'success.main' : 'error.main';

  return (
    <Box color={color} display="flex">
      <StatusIconCDS type={status} />
    </Box>
  );
};

BooleanCellContent.propTypes = {
  isChecked: PropTypes.bool,
};

export default memo(BooleanCellContent);
